function consoleLog(message) {
    console.log('[%s] %s', new Date().toISOString(), message);
}

function consoleInfo(message) {
    console.log('\x1b[96m[%s] %s\x1b[0m', new Date().toISOString(), message);
}

function consoleWarning(message) {
    console.warn('\x1b[93m[%s] %s\x1b[0m', new Date().toISOString(), message);
}

function consoleError(message) {
    console.error('\x1b[91m[%s] %s\x1b[0m', new Date().toISOString(), message);
}

function consoleTagLog(tag, message) {
    console.log('\x1b[97m[%s] [%s] %s\x1b[0m', new Date().toISOString(), tag, message);
}

function consoleTagInfo(tag, message) {
    console.info('\x1b[96m[%s] [%s] %s\x1b[0m', new Date().toISOString(), tag, message);
}

function consoleTagWarning(tag, message) {
    console.warn('\x1b[93m[%s] [%s] %s\x1b[0m', new Date().toISOString(), tag, message);
}

function consoleTagError(tag, message) {
    console.error('\x1b[91m[%s] [%s] %s\x1b[0m', new Date().toISOString(), tag, message);
}

export {
    consoleLog,
    consoleInfo,
    consoleWarning,
    consoleError,
    consoleTagLog,
    consoleTagInfo,
    consoleTagWarning,
    consoleTagError,
};
